// extracted by mini-css-extract-plugin
module.exports = {"wpopt":"wpopt--mZDXK","circleMove":"circleMove--1EVER","heartMove":"heartMove--24mFl","wpopt_big":"wpopt_big--DM_of","okMove":"okMove--20eQJ"};